import { createContext } from 'react';
import { type ModalTitle } from './types';

interface ImportCandidateModalContextValue {
  isOpen: boolean;
  modalTitle: ModalTitle;
  solutionId?: string;
  openModal: () => void;
  closeModal: () => void;
}

const ImportCandidateModalContext = createContext<ImportCandidateModalContextValue>({
  isOpen: false,
  modalTitle: 'New Solution',
  solutionId: undefined,
  openModal: (): void => {
    // noop default context handler
  },
  closeModal: (): void => {
    // noop default context handler
  },
});

export default ImportCandidateModalContext;
